"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sticker = void 0;
exports.sticker = function (axios) {
    return {
        /** @deprecated getStickersByMallNoV2 사용해주세요 */
        getStickersByMallNo: function (getStickersByMallNoRequest) {
            var url = "/stickers/malls/" + getStickersByMallNoRequest.params.mallNo;
            return axios.get(url, getStickersByMallNoRequest);
        },
        getStickersByMallNoV2: function (getStickersByMallNoRequest) {
            var url = "/stickers/malls/" + getStickersByMallNoRequest.params.mallNo;
            return axios.get(url, getStickersByMallNoRequest);
        },
        putStickers: function (putStickersRequest) {
            return axios.put('/stickers', putStickersRequest.data);
        },
        getStickersUsable: function (getStickersUsableRequest) {
            return axios.get('/stickers/usable', getStickersUsableRequest);
        },
        /** @deprecated getStickerV2 사용해주세요 */
        getSticker: function (getStickerRequest) {
            var url = "/stickers/" + getStickerRequest.params.stickerNo + "/malls/" + getStickerRequest.params.mallNo;
            return axios.get(url, getStickerRequest);
        },
        getStickerV2: function (getStickerRequest) {
            var url = "/stickers/" + getStickerRequest.params.stickerNo + "/malls/" + getStickerRequest.params.mallNo;
            return axios.get(url, getStickerRequest);
        }
    };
};
